module.exports = __webpack_public_path__ + "static/media/medall.3d23341e.svg";